<template>
  <footer>
    <div class="w-full bg-black px-6">
      <div class="mx-auto max-w-[1300px] py-20 flex flex-col-reverse lg:flex-row flex-wrap items-center xl:items-end ">
        <div class="flex-1 text-white text-2xl text-center lg:text-left mt-12 lg:mt-0">
          <p>A TRADITION SINCE 1865</p>
          <p>© {{ currentYear }} {{ title }} Publishing</p>
          <p>480-922-5202 | Scottsdale, Arizona</p>
        </div>


        <div class="flex-1 text-center text-white">
          <p class="text-4xl tracking-widest font-light text-grayLight">STAY IN TOUCH</p>
          <p class="text-lg text-grayMedium">For exclusive content, subscribe to our newsletter</p>
          <div
              class="sm:border border-white flex-col sm:flex-row flex items-center w-full mt-4 space-y-4 sm:space-y-0 text-2xl">
            <input v-model="email"
                   class="w-full bg-black px-2 h-[58px]"
                   placeholder="Email Address"/>
            <button
                @click="modal=true"
                class="focus:outline-none focus:ring-offset-2 focus:ring border border-white sm:border-transparent w-full sm:w-auto bg-grayLight2 py-4 px-6 hover:bg-opacity-75 text-black font-semibold">
              GO
            </button>
          </div>
        </div>

        <div
            class="flex items-center flex-col justify-center overflow-hidden fixed inset-0 z-30"
            v-show="modal"
        >
          <transition
              enter-active-class="transition duration-150 ease-in"
              enter-from-class="opacity-0"
              enter-to-class="opacity-100"
              leave-active-class="transition duration-150 ease-in"
              leave-from-class="opacity-100"
              leave-to-class="opacity-0"
          >
            <div
                class="absolute inset-0 bg-gradient-to-tr opacity-90 from-gray-700 via-gray-900 to-gray-700 dark:from-gray-700 dark:via-gray-900 dark:to-gray-700"
                @click="modal = false"
            />
          </transition>
          <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="animate-fadeOut"
          >
            <admin-card-component
                v-if="modal"
                class="shadow-lg w-full md:w-3/5 lg:w-2/5 z-40"
                rounded="rounded-lg"
                :header-icon="mdiClose"
                modal hasTable
                @header-icon-click="modal = false"
            >
              <div id="mc_embed_shell"  class="bg-white items-center">

                <div id="mc_embed_signup">

                  <form
                      action="https://nationalhorseman.us21.list-manage.com/subscribe/post?u=4bf8832a6cb1f49cfa5fbc4fa&amp;id=91716d7fce&amp;f_id=0082ede6f0"
                      method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate"
                      target="_blank">

                    <div id="mc_embed_signup_scroll">
                      <div class="pt-2 pb-2 pl-2 pr-[30px] bg-black rounded relative">
                        <h2 class="text-white ">NH Online Insider: Join our e-mail list to get the latest &amp;
                          greatest info!
                        </h2>

                        <div class="absolute top-0 right-0">
                          <button
                              @click="modal=false"
                              class="p-2 mr-2 w-[30px] h-[30px] focus:outline-none focus:ring-offset-2 focus:ring sm:border-transparent w-full sm:w-auto border text-white border-white hover:bg-opacity-75 font-semibold">
                            x
                          </button>
                        </div>
                      </div>



                      <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>


                      <div class="mb-4 flex flex-col sm:flex-row">
                        <div class="sm:basis-2/4 flex flex-col">
                          <div class="mc-field-group"><label class="font-bold" for="mce-EMAIL">Email Address <span
                              class="asterisk">*</span></label><input v-model="email" type="email" name="EMAIL"
                                                                      class="required email" id="mce-EMAIL" required=""
                          ></div>
                        </div>
                        <div class="sm:basis-2/4 flex flex-col">
                          <div class="mc-field-group"><label class="font-bold" for="mce-FNAME">First Name <span
                              class="asterisk">*</span></label><input type="text" name="FNAME" class="required text"
                                                                      id="mce-FNAME" required="" value=""></div>
                        </div>
                      </div>
                      <div class="mb-4 flex flex-col sm:flex-row">
                        <div class="basis-2/4 flex flex-col">
                          <div class="mc-field-group"><label class="font-bold" for="mce-LNAME">Last Name </label><input type="text"
                                                                                                                        name="LNAME"
                                                                                                                        class=" text"
                                                                                                                        id="mce-LNAME"
                                                                                                                        value=""></div>
                        </div>
                        <div class="basis-2/4 flex flex-col">
                          <div class="mc-field-group size1of2"><label class="font-bold" for="mce-BIRTHDAY-month">Birthday </label>
                            <div class="datefield"><span class="subfield monthfield"><input class="birthday REQ_CSS"
                                                                                            type="text" pattern="[0-9]*"
                                                                                            placeholder="MM" size="2"
                                                                                            maxlength="2"
                                                                                            name="BIRTHDAY[month]"
                                                                                            id="mce-BIRTHDAY-month"
                                                                                            value=""></span> /<span
                                class="subfield dayfield"><input class="birthday REQ_CSS" type="text" pattern="[0-9]*"
                                                                 placeholder="DD" size="2" maxlength="2"
                                                                 name="BIRTHDAY[day]" id="mce-BIRTHDAY-day" value=""></span><span
                                class="small-meta nowrap">( mm / dd )</span></div>
                          </div>
                        </div>
                      </div>




                      <div class="mc-field-group input-group"><strong>Select all breeds that apply to you: </strong>
                        <ul>
                          <li><input type="checkbox" name="group[2016][1]" id="mce-group[2016]-2016-0" value=""><label class="ml-1 font-medium"
                              for="mce-group[2016]-2016-0">Saddlebred</label></li>
                          <li><input type="checkbox" name="group[2016][2]" id="mce-group[2016]-2016-1" value=""><label class="ml-1 font-medium"
                              for="mce-group[2016]-2016-1">Morgan horse</label></li>
                          <li><input type="checkbox" name="group[2016][4]" id="mce-group[2016]-2016-2" value=""><label class="ml-1 font-medium"
                              for="mce-group[2016]-2016-2">Arabian/Half-Arabian</label></li>
                          <li><input type="checkbox" name="group[2016][8]" id="mce-group[2016]-2016-3" value=""><label class="ml-1 font-medium"
                              for="mce-group[2016]-2016-3">Dutch/Hackney/Friesian/Other</label></li>
                        </ul>
                      </div>

                      <div hidden=""><input type="hidden" name="tags" value="2971476"></div>

                      <div id="mce-responses" class="clear">

                        <div class="response" id="mce-error-response" style="display: none;"></div>

                        <div class="response" id="mce-success-response" style="display: none;"></div>

                      </div>
                      <div aria-hidden="true" style="position: absolute; left: -5000px;"><input type="text"
                                                                                                name="b_4bf8832a6cb1f49cfa5fbc4fa_91716d7fce"
                                                                                                tabindex="-1" value="">
                      </div>
                      <div class="clear"><input type="submit" name="subscribe" id="mc-embedded-subscribe" class="button"
                                                value="Subscribe"></div>

                    </div>

                  </form>

                </div>
              </div>


              <!--              <div id="mc_embed_shell" class="bg-white items-center">-->
              <!--                <div id="mc_embed_signup">-->
              <!--                  <form-->
              <!--                      action="https://nationalhorseman.us21.list-manage.com/subscribe/post?u=4bf8832a6cb1f49cfa5fbc4fa&amp;id=91716d7fce&amp;f_id=0082ede6f0"-->
              <!--                      method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate"-->
              <!--                      target="_blank">-->
              <!--                    <div id="mc_embed_signup_scroll"><h2>NH Online Insider: Join our e-mail list to get the latest &amp;-->
              <!--                      greatest info!</h2>-->
              <!--                      <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>-->
              <!--                      <div class="mc-field-group"><label for="mce-EMAIL">Email Address <span-->
              <!--                          class="asterisk">*</span></label><input-->
              <!--                          type="email" name="EMAIL" class="required email" id="mce-EMAIL" required="" v-model="email">-->
              <!--                      </div>-->
              <!--                      <div class="mc-field-group"><label for="mce-FNAME">First Name <span-->
              <!--                          class="asterisk">*</span></label><input type="text" name="FNAME" class="required text"-->
              <!--                                                                  id="mce-FNAME" required="" value=""></div>-->
              <!--                      <div class="mc-field-group"><label for="mce-LNAME">Last Name </label><input type="text"-->
              <!--                                                                                                  name="LNAME"-->
              <!--                                                                                                  class=" text"-->
              <!--                                                                                                  id="mce-LNAME"-->
              <!--                                                                                                  value=""></div>-->
              <!--                      <div class="mc-field-group size1of2"><label for="mce-BIRTHDAY-month">Birthday </label>-->
              <!--                        <div class="datefield"><span class="subfield monthfield"><input class="birthday REQ_CSS"-->
              <!--                                                                                        type="text"-->
              <!--                                                                                        pattern="[0-9]*"-->
              <!--                                                                                        placeholder="MM"-->
              <!--                                                                                        size="2" maxlength="2"-->
              <!--                                                                                        name="BIRTHDAY[month]"-->
              <!--                                                                                        id="mce-BIRTHDAY-month"-->
              <!--                                                                                        value=""></span> /<span-->
              <!--                            class="subfield dayfield"><input class="birthday REQ_CSS" type="text" pattern="[0-9]*"-->
              <!--                                                             placeholder="DD" size="2" maxlength="2"-->
              <!--                                                             name="BIRTHDAY[day]"-->
              <!--                                                             id="mce-BIRTHDAY-day" value=""></span><span-->
              <!--                            class="small-meta nowrap">( mm / dd )</span></div>-->
              <!--                      </div>-->
              <!--                      <div hidden=""><input type="hidden" name="tags" value="2971476"></div>-->
              <!--                      <div id="mce-responses" class="clear">-->
              <!--                        <div class="response" id="mce-error-response" style="display: none;"></div>-->
              <!--                        <div class="response" id="mce-success-response" style="display: none;"></div>-->
              <!--                      </div>-->
              <!--                      <div aria-hidden="true" style="position: absolute; left: -5000px;"><input type="text"-->
              <!--                                                                                                name="b_4bf8832a6cb1f49cfa5fbc4fa_91716d7fce"-->
              <!--                                                                                                tabindex="-1" value="">-->
              <!--                      </div>-->
              <!--                      <div class="clear">-->
              <!--                        <input @click="closeModal" type="submit" name="subscribe" id="mc-embedded-subscribe"-->
              <!--                               class="button"-->
              <!--                               value="Subscribe"></div>-->
              <!--                    </div>-->
              <!--                  </form>-->
              <!--                </div>-->
              <!--              </div>-->
            </admin-card-component>
          </transition>
        </div>


        <div class="flex-1 text-white">
          <div class="flex justify-center lg:justify-end space-x-4">
            <NuxtLink target="_blank" :to="twitter" aria-label="twitter">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                   xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30" height="30" x="0" y="0"
                   viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"
                   class="fill-black p-2 rounded-full hover:bg-white bg-grayLight"><g>
          <g xmlns="http://www.w3.org/2000/svg">
            <g>
              <path
                  d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016    c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992    c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056    c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152    c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792    c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44    C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568    C480.224,136.96,497.728,118.496,512,97.248z"
                  data-original="#000000" class=""/>
            </g>
          </g>
          </g></svg>
            </NuxtLink>
            <NuxtLink target="_blank" :to="facebook" aria-label="facebook">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                   xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30" height="30" x="0" y="0"
                   viewBox="0 0 155.139 155.139" style="enable-background:new 0 0 512 512" xml:space="preserve"
                   class="fill-black p-2 rounded-full hover:bg-white bg-grayLight"><g>
          <g xmlns="http://www.w3.org/2000/svg">
            <path id="f_1_" style=""
                  d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184   c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452   v20.341H37.29v27.585h23.814v70.761H89.584z"
                  data-original="#010002"/>
          </g></g></svg>
            </NuxtLink>
            <NuxtLink target="_blank" :to="instagram" aria-label="instagram">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                   xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30" height="30" x="0" y="0"
                   viewBox="0 0 511 511.9" style="enable-background:new 0 0 512 512" xml:space="preserve"
                   class="fill-black p-2 rounded-full hover:bg-white bg-grayLight"><g><path xmlns="http://www.w3.org/2000/svg" d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0" data-original="#000000" class=""/><path
                  xmlns="http://www.w3.org/2000/svg"
                  d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0"
                  data-original="#000000" class=""/><path xmlns="http://www.w3.org/2000/svg"
                                                          d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0"/></g></svg>
            </NuxtLink>
            <NuxtLink target="_blank" :to="youtube" aria-label="youtube">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                   xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30" height="30" x="0" y="0"
                   viewBox="0 0 409.592 409.592" style="enable-background:new 0 0 512 512" xml:space="preserve"
                   class="fill-black p-2 rounded-full hover:bg-white bg-grayLight"><g>
          <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
                d="M403.882,107.206c-2.15-17.935-19.052-35.133-36.736-37.437c-107.837-13.399-216.883-13.399-324.685,0    C24.762,72.068,7.86,89.271,5.71,107.206c-7.613,65.731-7.613,129.464,0,195.18c2.15,17.935,19.052,35.149,36.751,37.437    c107.802,13.399,216.852,13.399,324.685,0c17.684-2.284,34.586-19.502,36.736-37.437    C411.496,236.676,411.496,172.937,403.882,107.206z M170.661,273.074V136.539l102.4,68.27L170.661,273.074z"
                data-original="#000000"/>
          </g>
          </g></g></svg>
            </NuxtLink>
          </div>
          <div class="py-2 flex text-center lg:text-right lg:justify-end mt-4">
            <nav>
              <ul>
                <li class="font-medium text-xl flex flex-col md:flex-row">
                  <NuxtLink to="/privacy-policy" class="md:border-r md:border-white px-3 hover:underline">Privacy
                    Policy
                  </NuxtLink>
                  <NuxtLink to="/terms-conditions" class="md:border-r md:border-white px-3 hover:underline">Terms &
                    Conditions
                  </NuxtLink>
                  <NuxtLink to="/site-map" class="pl-3 hover:underline">Site Map</NuxtLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script setup>
import {computed, ref} from 'vue'
import {useDomainStore} from '~/stores/main'
import {mdiClose} from "@mdi/js";


const domainStore = useDomainStore();
const title = computed(() => domainStore.title);
const facebook = computed(() => domainStore.facebook);
const instagram = computed(() => domainStore.instagram);
const youtube = computed(() => domainStore.youtube);
const twitter = computed(() => domainStore.twitter);
const currentYear = ref(new Date().getFullYear());
const email = ref('');
const modal = ref(false);

const closeModal = () => {
  modal.value = false;
  email.value = '';
}

</script>
<style scoped>


#mc_embed_signup {
  background: #fff;
  clear: left;
  font: 14px Helvetica, Arial, sans-serif;
  //width: 400px;
}
</style>
